import script from "./FullVideo.vue?vue&type=script&lang=ts&setup=true"
export * from "./FullVideo.vue?vue&type=script&lang=ts&setup=true"

import "./FullVideo.vue?vue&type=style&index=0&id=26f8e71a&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f8e71a"]])

export default __exports__